<template>
  <div class="approval-flow-slot-field d-flex align-center ga-2 w-100">
    <span
      class="approval-flow-slot-field-label text-body-2 text-textLight font-weight-medium"
      :style="{ width: `${labelWidth}px` }"
    >
      {{ label }}
    </span>
    <div class="approval-flow-slot-field-value flex-grow-1 min-w-0">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    required: true,
  },
  labelWidth: {
    type: Number,
    default: 72,
  },
});
</script>
